import { render, staticRenderFns } from "./FormSelectStatic.vue?vue&type=template&id=ecf6c20a&"
import script from "./FormSelectStatic.vue?vue&type=script&lang=js&"
export * from "./FormSelectStatic.vue?vue&type=script&lang=js&"
import style0 from "./FormSelectStatic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports